export default __webpack_public_path__ + "static/media/EWallet_linked.4f509e68.svg";